__turbopack_context__.v({
  "breedLabel": "dogNameGeneratorPage-module-scss-module__ktsocG__breedLabel",
  "breedSelectorWrap": "dogNameGeneratorPage-module-scss-module__ktsocG__breedSelectorWrap",
  "callToAction": "dogNameGeneratorPage-module-scss-module__ktsocG__callToAction",
  "font1": "dogNameGeneratorPage-module-scss-module__ktsocG__font1",
  "font2": "dogNameGeneratorPage-module-scss-module__ktsocG__font2",
  "font3": "dogNameGeneratorPage-module-scss-module__ktsocG__font3",
  "font4": "dogNameGeneratorPage-module-scss-module__ktsocG__font4",
  "font5": "dogNameGeneratorPage-module-scss-module__ktsocG__font5",
  "font6": "dogNameGeneratorPage-module-scss-module__ktsocG__font6",
  "font7": "dogNameGeneratorPage-module-scss-module__ktsocG__font7",
  "font8": "dogNameGeneratorPage-module-scss-module__ktsocG__font8",
  "font9": "dogNameGeneratorPage-module-scss-module__ktsocG__font9",
  "generateButton": "dogNameGeneratorPage-module-scss-module__ktsocG__generateButton",
  "inputs": "dogNameGeneratorPage-module-scss-module__ktsocG__inputs",
  "inputsButtonContainer": "dogNameGeneratorPage-module-scss-module__ktsocG__inputsButtonContainer",
  "inputsGroup": "dogNameGeneratorPage-module-scss-module__ktsocG__inputsGroup",
  "inputsTitle": "dogNameGeneratorPage-module-scss-module__ktsocG__inputsTitle",
  "intro": "dogNameGeneratorPage-module-scss-module__ktsocG__intro",
  "introText": "dogNameGeneratorPage-module-scss-module__ktsocG__introText",
  "introTitle": "dogNameGeneratorPage-module-scss-module__ktsocG__introTitle",
  "introTitleBold": "dogNameGeneratorPage-module-scss-module__ktsocG__introTitleBold",
  "loading": "dogNameGeneratorPage-module-scss-module__ktsocG__loading",
  "nameResultsDisplay": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsDisplay",
  "nameResultsHeading": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsHeading",
  "nameResultsPlaceholder": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsPlaceholder",
  "nameResultsPlaceholderIcon": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsPlaceholderIcon",
  "nameResultsPlaceholderImg": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsPlaceholderImg",
  "nameResultsValue": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsValue",
  "nameResultsValues": "dogNameGeneratorPage-module-scss-module__ktsocG__nameResultsValues",
  "pageWrapper": "dogNameGeneratorPage-module-scss-module__ktsocG__pageWrapper",
  "placeholderCard": "dogNameGeneratorPage-module-scss-module__ktsocG__placeholderCard",
  "placeholderIcon": "dogNameGeneratorPage-module-scss-module__ktsocG__placeholderIcon",
  "results": "dogNameGeneratorPage-module-scss-module__ktsocG__results",
  "resultsBtnContainer": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsBtnContainer",
  "resultsBtnContainerButton": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsBtnContainerButton",
  "resultsContainer": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsContainer",
  "resultsInputs": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsInputs",
  "resultsResultsArea": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsResultsArea",
  "resultsShare": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsShare",
  "resultsTitle": "dogNameGeneratorPage-module-scss-module__ktsocG__resultsTitle",
  "sexSelector": "dogNameGeneratorPage-module-scss-module__ktsocG__sexSelector",
  "sexSelectorIcon": "dogNameGeneratorPage-module-scss-module__ktsocG__sexSelectorIcon",
  "sexSelectorLabel": "dogNameGeneratorPage-module-scss-module__ktsocG__sexSelectorLabel",
  "sexSelectorOption": "dogNameGeneratorPage-module-scss-module__ktsocG__sexSelectorOption",
  "sexSelectorOptionLabel": "dogNameGeneratorPage-module-scss-module__ktsocG__sexSelectorOptionLabel",
  "sexSelectorOptions": "dogNameGeneratorPage-module-scss-module__ktsocG__sexSelectorOptions",
  "spin": "dogNameGeneratorPage-module-scss-module__ktsocG__spin",
  "spinner": "dogNameGeneratorPage-module-scss-module__ktsocG__spinner",
});
